<template>
    <!-- TODO: Better Desktop implementation  -->
    <div id="home-container">
        <div id="landing">
            <div id="page-title">
                <br>
                <h1>Flow, Dark Pool, & Crypto Stream</h1>
                <br>
                <v-img id="ofb-avatar" max-height="350"
                       max-width="775">
                    <img style="width: 100%;" src="../assets/flowPrem2.png" alt="ofb">
                </v-img>
                <br>
                    <p>- More Data - Unfiltered -</p>
                <p>   See what other services don't show you.</p>
                <p> <b><i>OFB Premium Plan (with flow) - $20/mo</i></b></p>

            </div>

            <div id="button-container">
                <v-btn
                        large
                        class="ma-2 white--text"
                        id="prem-button"
                        v-on:click="showLogin()"
                >
                    Sign up for Premium!
                    <img id="prem" src="../assets/ofbsvg.svg" alt="OFB Logo">
                </v-btn>


                <v-btn
                        large
                        class="ma-2 white--text"
                        id="join-OFB-discord-button"
                        v-on:click="joinOFBDiscord()"
                >
                    Join our Discord!
                    <img class="right-side-button-icon" src="../assets/Discord-Logo-White.svg" alt="Discord Logo">
                </v-btn>


            </div>
        </div>

        <FeaturesPrem/>

    </div>

</template>


<script>
    import FeaturesPrem from "./FeaturesPrem";

    // Auto scrolling
    let isScrolling = false
    let scrollIndex = 0
    let scrollReferences = [
        "#landing",
        "#dpandblocks",
        "#cryptoofb",
        "#breakout",
        "#shortvol",
        "#oidata",
        "#instdata",
        "#details",
    ]

    export default {
        name: 'Home',

        props: {
        },

        mounted() {
            window.scrollTo(0,0);
        },

        created () {
            window.addEventListener('wheel', this.handleScroll, { passive: false });
        },
        destroyed () {
            window.removeEventListener('wheel', this.handleScroll);
        },

        components: {
            FeaturesPrem
        },

        methods: {
            addToDiscord: function () {
                let win = window.open("https://discordapp.com/api/oauth2/authorize?client_id=452988914215550997&scope=bot&permissions=522310", '_blank');
                win.focus();
            },
            joinOFBDiscord: function () {
                let win = window.open("https://discord.gg/SpuDKjkJ7T", '_blank');
                win.focus();
            },

            showCommands: function() {
                this.$router.push({name: "Commands"});
            },

            showServers: function() {
                this.$router.push({name: "Servers"});
            },

            showLogin: function() {
                this.$router.push({name: "Login"});
            },

            showFeatures: function () {
                scrollIndex++
                this.$vuetify.goTo('#charting', {
                    duration: 850,
                    easing: "easeInOutCubic",
                })
            },

            handleScroll: function (event) {
                event.preventDefault()
                event.stopImmediatePropagation()

                if (isScrolling){
                    return
                } else {
                    isScrolling = true
                }

                if (event.deltaY < 0) {
                    this.scrollUp()
                } else if (event.deltaY > 0) {
                    this.scrollDown()
                }

            },

            scrollUp: function () {
                if (scrollIndex > 0 ) {
                    scrollIndex--
                } else {
                    scrollIndex = scrollReferences.length - 1
                }

                this.$vuetify.goTo(scrollReferences[scrollIndex], {
                    duration: 850,
                    easing: "easeInOutCubic",
                }).then(function () {
                    isScrolling = false
                })
            },

            scrollDown: function () {
                if (scrollIndex < scrollReferences.length - 1){
                    scrollIndex++
                } else {
                    scrollIndex = 0
                }

                this.$vuetify.goTo(scrollReferences[scrollIndex], {
                    duration: 850,
                    easing: "easeInOutCubic",
                }).then(function () {
                    isScrolling = false
                })
            }
        },

        data: () => ({
            newUpdate: false,
        }),
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    html {
        background-color: #292929;
    }

    #ofb-avatar{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }

    #home-container {
        height: auto;
        width: 100%;
        padding: 10px 10px 10px 10px;
        background-color: #292929;
    }

    #landing {
        height: calc(100vh - 5rem);
        display: flex;
        flex-direction: column;

        padding-top: .1rem;
        justify-content: flex-start;
        align-items: center;
    }

    h1 {
        font-size: 35px;
        font-weight: bold;
        text-align: center;
        color: #FFFFFF;
    }

    p {
        text-align: center;
        font-size: 22px;
        color: #bebebe;
    }

    #button-container {
        display: grid;
        align-self: start;
        align-items: start;
        grid-template-rows: fit-content(1em) fit-content(1em) fit-content(1em);

        height: auto;
        width: 100%;
        margin-top: 15px;
    }

    #discord-button {
        position: relative;
        height: 52px;
        background-color: #7289DA;
    }

    #server-button {
        position: relative;
        height: 52px;
        background-color: #404040;
    }

    #slack-button {
        height: 52px;
        background-color: #4A154B;
    }

    #prem-button {
        height: 52px;
        background-color: #15454b;
    }

    #commands-button {
        height: 52px;
        background-color: #404040;
    }

    #join-OFB-discord-button {
        height: 52px;
        background-color: #404040;
    }

    #features-button {
        height: 52px;
        background-color: #404040;
    }

    #slack-is-annoying {
        position: absolute;
        height: 25px;
        right: 0;
    }

    #prem {
        position: absolute;
        height: 25px;
        right: 0;
    }

    .right-side-button-icon {
        position: absolute;
        height: 30px;
        right: 0;
    }

    #action-buttons {
        display: flex;
        flex-direction: column;
    }

    @media screen and (min-width: 750px) {

        #home-container {
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        }

        #landing {
            height: 90vh;
            display: flex;
            flex-direction: column;

            justify-content: center;
            align-items: center;
        }

        h1 {
            font-size: 45px;
        }

        p {
            font-size: 30px;
        }

        #page-title {
            max-width: 775px;
        }

        #button-container {
            width: 50%;
            align-self: center;
            max-width: 450px;

        }

        #action-buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        #commands-button {
            width: 45%;
        }

        #features-button {
            width: 45%;
        }
    }


</style>